module.exports = __webpack_public_path__ + "img/index-small.5c5480e5.jpg";